import { cn } from '@bem-react/classname'
import './Partners.scss'
import { FC } from 'react'
import crystal from '@/assets/img/crystal.png'
import sumsub from '@/assets/img/sumsub.png'
import cryptoApis from '@/assets/img/crypto-apis.png'
import okx from '@/assets/img/okx.png'

const cnPartners = cn('Partners')

interface PartnersProps {
	className?: string
}

export const Partners: FC<PartnersProps> = ({
	className
}: PartnersProps): JSX.Element => {
	return (
		<div className={cnPartners(null, [className])}>
			<div className={cnPartners('partner')}>
				<img
					src={crystal}
					alt='img'
					width={153}
					height={32}
				/>
			</div>
			<div className={cnPartners('partner')}>
				<img
					src={sumsub}
					alt='img'
					width={141}
					height={32}
				/>
			</div>
			<div className={cnPartners('partner')}>
				<img
					src={cryptoApis}
					alt='img'
					width={170}
					height={32}
				/>
			</div>
			<div className={cnPartners('partner')}>
				<img
					src={okx}
					alt='img'
					width={80}
					height={32}
				/>
			</div>
		</div>
	)
}